module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/description-pict-444fc1e5276de6cac820fe55ab720cd8.jpg";